import { AbstractControl, ValidationErrors } from "@angular/forms";

export const decimalValidator = (control: AbstractControl): ValidationErrors | null => {
  const decimal = control.value;
  return /^\d+([,.]\d+)?$/.test(decimal) ? null : {decimal};
};